import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { ChangeEvent, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import RequiredStar from "../../lib/RequiredStar";
import InputErrorMsg from "../form-builder-helpers/InputErrorMsg";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
}

const minRows = 1;
const maxRows = 5;

const TextAreaHook: React.FC<Props> = ({ form, field }) => {
  const t = useTranslation();
  const [rows, setRows] = useState(2);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const textareaLineHeight = 18;
    const previousRows = event.target.rows;
    event.target.rows = minRows;
    const currentRows = ~~(
      (event.target.scrollHeight - 16) /
      textareaLineHeight
    );
    if (currentRows === previousRows) event.target.rows = currentRows;
    else if (currentRows >= maxRows) {
      event.target.rows = maxRows;
      event.target.scrollTop = event.target.scrollHeight;
    }
    setRows(currentRows < maxRows ? currentRows : maxRows);
  };
  const fConfig = field.configurations;

  return (
    <div className="w-100">
      {!fConfig.hideLabel && (
        <RequiredStar title={fConfig.title} isRequired={fConfig.is_required} />
      )}
      <textarea
        rows={rows}
        {...form.register(fConfig.key, {
          required: fConfig.is_required
            ? (t.requiredMsg = t.this_field_is_required)
            : "",
        })}
        placeholder={fConfig.placeholder ?? fConfig.title}
        className={"textarea"}
        onChange={handleChange}
      />
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      <InputErrorMsg
        errorMsg={form.formState.errors[fConfig.key]?.message as string}
      />
    </div>
  );
};
export default TextAreaHook;
